import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './Login';
import AdminLayout from './AdminLayout';
import RequireAdmin from './RequireAdmin';
import NewsDashboard from './NewsDashboard';
import NewsNew from './NewsNew';
import NewsEdit from './NewsEdit';
import FooterDashboard from './FooterDashboard';
import ProductsDashboard from './ProductsDashboard';
import ProductNew from './ProductNew';
import ProductEdit from './ProductEdit';
import SeedVarietiesDashboard from './SeedVarietiesDashboard';
import SeedVarietyCategoriesDashboard from './SeedVarietyCategoriesDashboard';
import SeedVarietyCategoryNew from './SeedVarietyCategoryNew';
import SeedVarietyCategoryEdit from './SeedVarietyCategoryEdit';
import SeedVarietyProductNew from './SeedVarietyProductNew';
import SeedVarietyProductEdit from './SeedVarietyProductEdit';
import SeedVarietyVariantNew from './SeedVarietyVariantNew';
import SeedVarietyVariantEdit from './SeedVarietyVariantEdit';
import GalleryDashboard from './GalleryDashboard';
import GalleryNew from './GalleryNew';
import GalleryEdit from './GalleryEdit';
import GalleryAlbums from './GalleryAlbums';
import ImpactStatsDashboard from './ImpactStatsDashboard';
import BrandTickerDashboard from './BrandTickerDashboard';
import HeaderDashboard from './HeaderDashboard';
import HeroDashboard from './HeroDashboard';
import AboutDashboard from './AboutDashboard';
import HistoryDashboard from './HistoryDashboard';
import FarmerDashboard from './FarmerDashboard';
import FounderDeskDashboard from './FounderDeskDashboard';
import SustainableFarmingDashboard from './SustainableFarmingDashboard';
import SeoDashboard from './SeoDashboard';
import UsersDashboard from './UsersDashboard';
import ChangePassword from './ChangePassword';

export default function AdminApp() {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path="dashboard" element={<AdminLayout />}>
        <Route index element={<Navigate to="news" replace />} />
        <Route
          path="header"
          element={
            <RequireAdmin>
              <HeaderDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="hero"
          element={
            <RequireAdmin>
              <HeroDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="about"
          element={
            <RequireAdmin>
              <AboutDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="history"
          element={
            <RequireAdmin>
              <HistoryDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="farmer"
          element={
            <RequireAdmin>
              <FarmerDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="founder-desk"
          element={
            <RequireAdmin>
              <FounderDeskDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="sustainable-farming"
          element={
            <RequireAdmin>
              <SustainableFarmingDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="brand-ticker"
          element={
            <RequireAdmin>
              <BrandTickerDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="impact-stats"
          element={
            <RequireAdmin>
              <ImpactStatsDashboard />
            </RequireAdmin>
          }
        />
        <Route path="news/new" element={<NewsNew />} />
        <Route path="news/:articleId/edit" element={<NewsEdit />} />
        <Route path="news" element={<NewsDashboard />} />
        <Route path="products/new" element={<ProductNew />} />
        <Route path="products/:productId/edit" element={<ProductEdit />} />
        <Route path="products" element={<ProductsDashboard />} />
        <Route path="seed-varieties/categories/new" element={<SeedVarietyCategoryNew />} />
        <Route path="seed-varieties/categories/:categoryId/edit" element={<SeedVarietyCategoryEdit />} />
        <Route path="seed-varieties/categories" element={<SeedVarietyCategoriesDashboard />} />
        <Route path="seed-varieties/products/new" element={<SeedVarietyProductNew />} />
        <Route path="seed-varieties/products/:productId/variants/new" element={<SeedVarietyVariantNew />} />
        <Route
          path="seed-varieties/products/:productId/variants/:variantId/edit"
          element={<SeedVarietyVariantEdit />}
        />
        <Route path="seed-varieties/products/:productId/edit" element={<SeedVarietyProductEdit />} />
        <Route path="seed-varieties" element={<SeedVarietiesDashboard />} />
        <Route path="gallery/new" element={<GalleryNew />} />
        <Route path="gallery/:itemId/edit" element={<GalleryEdit />} />
        <Route path="gallery/albums" element={<GalleryAlbums />} />
        <Route path="gallery" element={<GalleryDashboard />} />
        <Route path="password" element={<ChangePassword />} />
        <Route
          path="seo"
          element={
            <RequireAdmin>
              <SeoDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="footer"
          element={
            <RequireAdmin>
              <FooterDashboard />
            </RequireAdmin>
          }
        />
        <Route
          path="users"
          element={
            <RequireAdmin>
              <UsersDashboard />
            </RequireAdmin>
          }
        />
      </Route>
    </Routes>
  );
}
